export default __webpack_public_path__ + "static/media/privilege-ticket.31478b05.svg";